import { Button } from '@/components/ui/Button';
import { useForceSync } from '@/hooks/useAdminDomains';
import { RefreshCw } from 'lucide-react';

interface ForceSyncButtonProps {
  domainUuid: string;
}

export function ForceSyncButton({ domainUuid }: ForceSyncButtonProps) {
  const forceSync = useForceSync();

  return (
    <Button
      variant="outline"
      size="sm"
      icon={<RefreshCw className="h-3.5 w-3.5" />}
      onClick={() => forceSync.mutate(domainUuid)}
      loading={forceSync.isPending}
    >
      Forcer la sync
    </Button>
  );
}
